import React, { Component } from 'react';
import PropTypes from 'prop-types';
import config from 'cityads-v3/config';

import Icon from '@material-ui/core/Icon';

import './Rating.scss';

export default class Rating extends Component {

  static propTypes = {
    level: PropTypes.number
  }

  render(){
    const stars = [];
    const float = this.props.level % 1;
    const integer = this.props.level - float;

    for (let i = 0; i < config.RATING_STAR_COUNT; i++){
      stars.push(
        i < integer ? 'star' :
          i === integer && float ? 'star_half' : 'star_border'
      );
    }

    return (
      <div className="rating">
        {stars.map((item, num) => (
          <Icon
            key={num}
            className="rating__star"
          >{item}</Icon>
        ))}
        {this.props.level}
      </div>
    );
  }
}
